module.exports = __webpack_public_path__ + "static/9000-label-and-breather-vents-b8ee3cd74478c0d00986e458b7b21f4c.jpg";